import { writable } from 'svelte/store';

export const ratio = writable(0);
export const theme = writable("light");